import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20e2a7dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20e2a7dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2a7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e2a7dc')) {
      api.createRecord('20e2a7dc', component.options)
    } else {
      api.reload('20e2a7dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20e2a7dc&scoped=true", function () {
      api.rerender('20e2a7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jhyc/store/info/index.vue"
export default component.exports